import { createContext } from 'react';

import type { EnvironmentContextValue } from './environmentContextTypes';

export const EnvironmentContext = createContext<EnvironmentContextValue | null>(
  null
);
